import _ from 'lodash';
import Vue from 'vue';
import moment from 'moment';
import 'moment-timezone';
import {mapActions, mapState, mapGetters} from 'vuex';
import {UrlModuleConstant, BioServicesConstant} from '../../constants';
import BioResults from './bioresults.html';
import BioAdmin from 'types/ba/bioAdmin';
import BioResultsSorter from '../../helpers/bioResultsSorter';

interface IComponentData {
	biosDisableImageCheck: boolean;
}

const bioResultsSorter: BioAdmin.IBioResultsSorter = new BioResultsSorter();

export default Vue.component('bioResults', {
	template: BioResults,
	props: ['results'],
	data(): IComponentData {
		return {
			biosDisableImageCheck: false,
		};
	},
	computed: {
		...mapGetters(UrlModuleConstant.name, {
			getGlobalPageDriverUrl: UrlModuleConstant.getter.getGlobalPageDriverUrl,
			getUrlParameter: UrlModuleConstant.getter.getUrlParameter,
		}),
		manageProfilePath: function() : string {
			return this.getGlobalPageDriverUrl('biosAdmin', 'manageProfile');
		},
		sortedResults: function() : BioAdmin.ITeamMemberListProfile[] {
			return bioResultsSorter.sortByPublishStatus(this.results);
		},
	},
	methods: {
		...mapActions(UrlModuleConstant.name, {
			synchronizeUrlStore: UrlModuleConstant.action.synchronize,
		}),
		localTime(date: string): string {
			return moment.tz(date, moment.tz.guess()).format(BioServicesConstant.localDateFormat);
		},
	},
	created(): void {
		const featureFlags = window.lt.features;
		if (featureFlags) {
			const feature = featureFlags[featureFlags.findIndex( (x: any) => x.featureId === 'biosDisableImageCheck')];
			if (feature) {
				this.biosDisableImageCheck = feature.enabled;
			}
		}
	},
});
